import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-liquidation',
    templateUrl: './icon-liquidation.component.html'
})
export class IconLiquidationComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
